import React, { useContext } from "react";
import { MatchContext } from "../../../context";

const Input = ({ ...props }) => {
  const { state } = useContext(MatchContext);
  const errTag = `${props.id.toUpperCase()}-${props.datatype}`;

  return (
    <input className={state.inputErrors[errTag] && "errInput"} {...props} />
  );
};

export default Input;
